'use client'

import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetUploadFileTypesDto, GetUploadFileTypesResponse, uploadFileTypeMappers } from '../../lib'

const getUploadFileTypes = async (params: GetUploadFileTypesDto = {}) => {
  const res = await api.json<GetUploadFileTypesResponse>(API_END_POINTS.uploadFileType.getUploadFileTypes(params))

  if (res.ok) {
    return uploadFileTypeMappers.mapUploadFileTypes(res.result || [])
  }

  throw new Error(res?.message || res?.error)
}

export default getUploadFileTypes
